/* eslint-disable camelcase */
/**
 * 查询用户信息或刷新token
 */

import { post } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';
import { NextRequest } from 'next/server';

export interface ResfreshTokenRes {
  code: number;
  message: string;
  nonce: string;
  data: {
    app_id: string;
    userid: string;
    nick_name: string;
    avatar: string;
    avatar_type: string;
    area: string;
    phone: string;
    email: string;
    name: string;
    gender: string;
    postion: string;
    department: string;
    user_type: string;
    corp_id: string;
    corp_name: string;
    login_tag: string;
    user_district: string;
    role_id: string;
    /**
     * 企业类型：8:渠道代理商，9:渠道代理商客户
     */
    corp_type: string | number;
  };
}
export enum LOGINSTATUS {
  UNREQUEST,
  LOADING,
  SUCCESS,
  ERROR,
}
export const defaultInfo = {
  app_id: '',
  userid: '',
  nick_name: '',
  avatar: '',
  avatar_type: '',
  area: '',
  phone: '',
  email: '',
  name: '',
  gender: '',
  postion: '',
  department: '',
  user_type: '',
  corp_id: '',
  corp_name: '',
  login_tag: '',
  user_district: '',
  role_id: '',
};
export const userInfoStorage = {
  isLogin: false,
  loginRomateStatus: LOGINSTATUS.UNREQUEST, // 0 未请求， 1 请求中 3请求失败 2 请求成功
  userInfo: { ...defaultInfo },
};
let lastRequest: any = null;
const refreshTokenOrGetCorpInfo: any = async (
  ctx?: GetServerSidePropsContext,
  req?: NextRequest,
) => {
  if (userInfoStorage?.loginRomateStatus === LOGINSTATUS.LOADING) {
    return lastRequest;
  }

  userInfoStorage.loginRomateStatus = LOGINSTATUS.LOADING;
  const request = post<ResfreshTokenRes>(
    HttpPrefix.WEMEET_WEB_API,
    '/v2/account/login/refresh-token',
    {
      refresh_token: 0,
    },
    ctx,
    {},
    req,
  )
    .then((response) => {
      userInfoStorage.loginRomateStatus = LOGINSTATUS.SUCCESS;
      if (response?.code === 0) {
        userInfoStorage.userInfo = { ...response?.data };
        userInfoStorage.isLogin = true;
        return response;
      }
      userInfoStorage.userInfo = { ...defaultInfo };
      userInfoStorage.isLogin = false;
      return response;
    })
    .catch((error) => {
      userInfoStorage.loginRomateStatus = LOGINSTATUS.ERROR;
      throw error;
    });
  lastRequest = request;
  return request;
};
export default refreshTokenOrGetCorpInfo;
